import script from "./SubmissionsListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionsListPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionsListPage.vue?vue&type=style&index=0&id=3aa0a315&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa0a315"]])

export default __exports__